import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withProps, compose, renderNothing, branch } from 'recompose';
import { Table } from 'react-bootstrap';


import NewTabLink from '../../../components/NewTabLink';
import { getTicketLink } from '../../ticketViewer/links';

const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  ticketNumber: PropTypes.object.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  title: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  equipmentNumbers: PropTypes.string,
  userNames: PropTypes.string,
  departmentName: PropTypes.string,
  districtName: PropTypes.string,
  leaseName: PropTypes.string,
  operatorName: PropTypes.string,
  dateDisplay: PropTypes.string,
  url: PropTypes.string,
});


const TicketNumberDetails = (props) => {
  const {
    number,
    equipmentNumbers,
    userNames,
    departmentName,
    districtName,
    title,
    leaseName,
    operatorName,
    dateDisplay,
    url,
  } = props;

  let link = `${title} - ${number}`;
  if (url) {
    link = <NewTabLink to={url}>{link}</NewTabLink>;
  }

  return (
    <div>
      <h3>{link}</h3>
      <div className="panel panel-default">
        <Table>
          <thead />
          <tbody>
            <tr>
              <td>Date:</td>
              <td>{ dateDisplay }</td>
            </tr>
            <tr>
              <td>Users:</td>
              <td>{ userNames }</td>
            </tr>
            <tr>
              <td>Department:</td>
              <td>{ departmentName }</td>
            </tr>
            <tr>
              <td>District:</td>
              <td>{ districtName }</td>
            </tr>
            <tr>
              <td>Equipment:</td>
              <td>{ equipmentNumbers }</td>
            </tr>
            <tr>
              <td>Operator:</td>
              <td>{ operatorName }</td>
            </tr>
            <tr>
              <td>Lease:</td>
              <td>{ leaseName }</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};


TicketNumberDetails.propTypes = propTypes;


const withFlattenData = withProps((props) => {
  const { number, ticket, users } = props.ticketNumber;
  const userNames = users.edges.map((edge) => { return edge.node.fullname; }).join(', ');

  if (ticket) {
    const { date, department, district, equipment, well, jobId, id } = ticket;
    const { lease } = well;
    const { operator } = lease;
    const equipmentNumbers = equipment.edges.map((edge) => { return edge.node.equipmentNumber; }).join(', ');
    const departmentName = department.name;
    const districtName = district.name;
    const leaseName = lease.name;
    const operatorName = operator.name;
    const dateDisplay = date.display;
    return {
      number,
      userNames,
      equipmentNumbers,
      departmentName,
      districtName,
      leaseName,
      operatorName,
      dateDisplay,
      url: getTicketLink(id, jobId),
    };
  }

  return {
    number,
    userNames,
  };
});


const withHide = branch(
  (props) => { return props.ticketNumber === null; },
  renderNothing,
);


const enhance = compose(
  withHide,
  withFlattenData,
);


export default enhance(TicketNumberDetails);
